import LoadStylesService from '../../../shared/services/LoadStylesService';

export default class ModalConnectionChunk {
  private isLoggedSelector = '.is-logged';

  private initImportSelector = '.js-openModalConnection, .popup-connexion';

  private autoTriggerPopupLoginSelector = '.popup_login';

  private noClosePopupLoginSelector = '.popup_login--no-close';

  private cssLoadedSelector = '.js-openModalConnection--cssLoaded';

  constructor() {
    if (document.querySelector(this.isLoggedSelector)) return;

    const onClick = ({ target }: MouseEvent) => {
      if (target instanceof HTMLElement) {
        const clickedElement = target.matches(this.initImportSelector)
          ? target
          : target.closest<HTMLElement>(this.initImportSelector);

        if (!clickedElement) return;

        this.importModalConnection(clickedElement);
        this.importCSS();
        document.body.removeEventListener('click', onClick);
      }
    };

    const isAutoTriggerPopupLogin = !!document.querySelector(
      this.autoTriggerPopupLoginSelector
    );
    const isRemovable = !document.querySelector(this.noClosePopupLoginSelector);

    if (isAutoTriggerPopupLogin) {
      this.importModalConnection(true, isRemovable);
      this.importCSS();
    } else {
      document.body.addEventListener('click', onClick);
    }
  }

  private importModalConnection(
    clickedElementOrAutoload: HTMLElement | boolean,
    isRemovable = true
  ) {
    import(
      /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-ModalConnection' */ '../../../components/ModalConnection/ModalConnection'
    ).then(({ default: ModalConnection }) => {
      new ModalConnection(clickedElementOrAutoload, isRemovable);
    });
  }

  private importCSS = () => {
    const cssModalConnectionUrlBearer: HTMLElement = document.querySelector(
      '[data-css-modal-connection]'
    );

    if (
      !cssModalConnectionUrlBearer.classList.contains(this.cssLoadedSelector)
    ) {
      const { cssModalConnection } = cssModalConnectionUrlBearer.dataset;
      cssModalConnectionUrlBearer.classList.add(this.cssLoadedSelector);
      LoadStylesService.loaderStyle(cssModalConnection);
    }
  };
}
